import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  fetchId,
  selectLoading,
  fetchRole,
  selectRole,
  selectDataId,
  editItem,
  addOfficeUser,
  selectDataIdUser,
  fetchIdUser,
  editEmployee,
  removeUserOffice,
  unlockUserUpdate,
  resetUserUpdate,
  selectRoleModal,
  fetchRoleModal,
  editOfficeUser,
} from "../user/userSlice";
import {
  formLabelsTheme,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { ModalOffice } from "./ModalOffice";
import { ModalClient } from "./ModalClient";
import { addLabelTpl, uploadFile } from "./motorPoolSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const LabelTemplateCreate = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectDataId);
  const dataOffice = useSelector(selectOffice);
  const dataUser = useSelector(selectDataIdUser);
  const dataActivities = useSelector(selectParameter);
  const dataServices = useSelector(selectParameter2);
  const { id } = useParams();

  const [listOffice, setListOffice] = useState([]);
  const [listClient, setListClient] = useState([]);
  const [activities, setActivities] = useState([]);
  const [services, setServices] = useState([]);
  const [copies, setCopies] = useState("");

  const [fileName, setFileName] = useState("Upload Template File * ");
  const [file, setFile] = useState(null);
  // initial

  const [formValues, setFormValues] = useState({
    labeltpl_type: {
      value: "",
      error: false,
      required: "Y",
    },
    labeltpl_name: {
      value: "",
      error: false,
      required: "Y",
    },
    labeltpl_description: {
      value: "",
      error: false,
      required: "N",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchParameter({
          paramgroup_code: "ACTIVITIES",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "SERVICES",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  // HanldeSave

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    if (
      formValues.labeltpl_name.value.includes("<script>") ||
      formValues.labeltpl_name.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }

    if (file === null) {
      return showDialog("Please Input File");
    }

    const params = {
      labeltpl_type: formValues.labeltpl_type.value,
      labeltpl_name: formValues.labeltpl_name.value,
      labeltpl_description: formValues.labeltpl_description.value,
      activities: activities,
      services: services,
      offices: listOffice,
      clients: listClient,
    };

    console.log(params, "params");

    try {
      const response = await dispatch(addLabelTpl(params));

      console.log(response, "response");

      if (response.payload.status === 200) {
        const params = {
          file_type: "LABEL_TEMPLATE",
          object_id: response.payload.data.data.labeltpl_id,
          file: file,
        };
        console.log(params);
        try {
          const response = await dispatch(uploadFile(params));
          if (response.payload.data.status === 200) {
            const action = await showSuccessDialog(
              response.payload.data.message
            );
            await history.goBack();
          } else {
            console.log("else");
            showErrorDialog(response.payload.data.message);
          }
        } catch (error) {
          console.log("catch");

          showErrorDialog(error.message);
        }
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm"
            onClick={(e) => handleDelete(e, row, rowIndex, formatExtraData)}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columns = [
    {
      text: "Office Code",
      dataField: "office_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Office Name",
      dataField: "office_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "City",
      dataField: "City",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Country",
      dataField: "country_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      formatExtraData: listOffice,
    },
  ];
  const actionFormatterClient = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm"
            onClick={(e) =>
              handleDeleteClient(e, row, rowIndex, formatExtraData)
            }
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columnsClient = [
    {
      text: "Client Code",
      dataField: "client_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Client Name",
      dataField: "client_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "City",
      dataField: "City",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Country",
      dataField: "country_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatterClient,
      align: "center",
      headerAlign: "center",
      formatExtraData: listClient,
    },
  ];

  const handleDelete = (e, row, rowIndex, formatExtraData) => {
    const idColumn = row.office_id;
    const temp = [...formatExtraData];
    let items = temp.filter((value, index) => value.office_id !== idColumn);
    setListOffice(items);
  };

  const handleDeleteClient = (e, row, rowIndex, formatExtraData) => {
    const idColumn = row.client_id;
    const temp = [...formatExtraData];
    let items = temp.filter((value, index) => value.client_id !== idColumn);
    setListClient(items);
  };

  // modal office

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // modal Client

  const [showClient, setShowClient] = useState(false);

  const handleCloseClient = () => setShowClient(false);
  const handleShowClient = () => setShowClient(true);
  const icon = <SVG src={toAbsoluteUrl("/media/svg/icons/New/x-error.svg")} />;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleActivies = (activities_code) => {
    setActivities([...activities, { activities_code }]);
  };

  const handleActiviesRemove = (activities_code) => {
    const data = activities.filter(function(obj) {
      return obj.activities_code !== activities_code;
    });

    setActivities(data);
  };

  const handleServices = (service_code) => {
    setServices([...services, { service_code }]);
  };

  const handleServicesRemove = (service_code) => {
    const data = services.filter(function(obj) {
      return obj.services_code !== service_code;
    });

    setServices(data);
  };

  const optionsProduct = [{ label: "Product", value: "Product" }];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title text-white ">
            Create Label Template
          </CardHeaderTitle>
        </CardHeader>

        <CardBody>
          <ThemeProvider theme={formLabelsTheme}>
            <>
              {/* label */}
              <div>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Autocomplete
                      options={optionsProduct}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={
                        optionsProduct.find(
                          (option) =>
                            option.value === formValues.labeltpl_type.value
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        if (newValue === null) {
                          setFormValues({
                            ...formValues,
                            ["labeltpl_type"]: {
                              ...formValues["labeltpl_type"],
                              value: "",
                            },
                          });
                        } else {
                          setFormValues({
                            ...formValues,
                            ["labeltpl_type"]: {
                              ...formValues["labeltpl_type"],
                              value: newValue.value,
                            },
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <RedditTextField
                          required
                          className={classes.margin}
                          {...params}
                          label="Label Type"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          placeholder="Select"
                          name="labeltpl_type"
                          error={formValues.labeltpl_type.error}
                          helperText={
                            formValues.labeltpl_type.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      )}
                    />
                    <RedditTextField
                      label="Description"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="labeltpl_description"
                      value={formValues.labeltpl_description.value}
                      onChange={handleChange}
                      multiline
                      rows="4"
                    />
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      required
                      label="Label Name"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="labeltpl_name"
                      value={formValues.labeltpl_name.value}
                      onChange={handleChange}
                      error={formValues.labeltpl_name.error}
                      helperText={
                        formValues.labeltpl_name.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {icon} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                  </Col>
                </Row>
              </div>
              <hr />
              {/* services/activties */}

              <div>
                <h5 className="font-weight-boldest">
                  Associated Services/Activities
                </h5>
                <CardBody>
                  <div>
                    <p className="font-weight-boldest">Activities</p>
                    <Col xs={12} sm={3} md={8} lg={8}>
                      <Row>
                        {dataActivities.map((item, index) => {
                          return (
                            <>
                              <Col md={4}>
                                <Form.Check
                                  label={item.param_value}
                                  value={item.param_code}
                                  name="group1"
                                  type="checkbox"
                                  className="mr-8 mb-4"
                                  onChange={(e) => {
                                    if (e.target.checked === true) {
                                      handleActivies(item.param_code);
                                    } else {
                                      handleActiviesRemove(item.param_code);
                                    }
                                  }}
                                />
                              </Col>
                            </>
                          );
                        })}
                      </Row>
                    </Col>
                  </div>
                  <div>
                    <p className="font-weight-boldest">Services/Processes</p>
                    <Col xs={12} sm={3} md={8} lg={8}>
                      <Row>
                        {dataServices.map((item, index) => {
                          return (
                            <Col md={4}>
                              <Form.Check
                                label={item.param_value}
                                value={item.param_code}
                                name="group1"
                                type="checkbox"
                                className="mr-8 mb-4"
                                onChange={(e) => {
                                  if (e.target.checked === true) {
                                    handleServices(item.param_code);
                                  } else {
                                    handleServicesRemove(item.param_code);
                                  }
                                }}
                              />
                            </Col>
                          );
                        })}
                      </Row>
                    </Col>
                  </div>
                </CardBody>
              </div>
              <hr />
              {/* Parameter */}
              <div>
                <h5 className="font-weight-boldest">Parameter</h5>
                <CardBody>
                  <Form.Check
                    inline
                    label="No. of Copies"
                    name="group1"
                    type="checkbox"
                    className="mr-8 mb-4"
                    onChange={(e) => {
                      if (e.target.checked === true) {
                        setCopies("Y");
                      } else {
                        setCopies("N");
                      }
                    }}
                  />
                </CardBody>
              </div>
              <hr />
              {/* Template File */}
              <div>
                <h5 className="font-weight-boldest d-flex">
                  Template File <p className="color-red">*</p>
                </h5>
                <CardBody>
                  <Row>
                    <Col xs={12} sm={3} md={6} lg={6}>
                      <Form.File
                        type="file"
                        id="file_fpre"
                        custom
                        label={fileName}
                        onChange={(e) => {
                          setFile(e.target.files[0]);
                          setFileName(e.target.files[0].name);
                        }}
                        accept=".jrxml"
                      />
                    </Col>
                  </Row>
                </CardBody>
              </div>

              <hr />
              {/* Office */}
              <div>
                <h5 className="font-weight-boldest">Office</h5>

                <BootstrapTable
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container"
                  bootstrap4
                  
                  keyField="No"
                  data={listOffice}
                  columns={columns}
                  // sort={{ dataField: sortField, order: sortOrder }}
                  hover
                  striped
                  headerClasses="header-class"
                />

                <Row className="mt-6 justify-content-end">
                  <Button variant="outline-primary" onClick={handleShow}>
                    Add Office
                  </Button>
                </Row>
              </div>
              <hr />
              {/* Client */}
              <div>
                <h5 className="font-weight-boldest">Clients</h5>

                <BootstrapTable
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container"
                  bootstrap4
                  
                  keyField="client_id"
                  data={listClient}
                  columns={columnsClient}
                  hover
                  striped
                  headerClasses="header-class"
                />

                <Row className="mt-6 justify-content-end">
                  <Button variant="outline-primary" onClick={handleShowClient}>
                    Add Client
                  </Button>
                </Row>
              </div>
              <hr />

              {/* handleSave */}
              <Row className="mt-6 justify-content-end">
                <Button variant="primary" onClick={handleSave}>
                  Save
                </Button>
              </Row>
            </>
          </ThemeProvider>
        </CardBody>
      </Card>

      <ModalOffice
        isOpen={show}
        handleClose={handleClose}
        handleShow={handleShow}
        setListOffice={setListOffice}
        listOffice={listOffice}
      />

      <ModalClient
        isOpen={showClient}
        handleClose={handleCloseClient}
        handleShow={handleShowClient}
        setListClient={setListClient}
        listClient={listClient}
      />
    </>
  );
};
